<template>
	<section class="container-contact" :id="[index]">
		<div class="container">
			<div class="row">
				<div class="contact-block col-12">
					<h2>{{ contactPersonData.config.title }}</h2>
					<div class="row contact-information" v-for="(contactPerson, index) in contactPersonData.config.addressData"
						:key="index">
						<div class="col-md-6 picture">
							<img :src="`${contactPerson.photoUri}`" alt="">
						</div>
						<div class="col-md-8 col-lg-6 contact-data">
							<div class="row">
								<div class="col-12">
									<h2 v-if="contactPerson.firstName.value || contactPerson.lastName.value">
										{{ contactPerson.firstName.value }}, {{ contactPerson.lastName.value }}</h2>
								</div>
								<div class="col-3 contact-field" v-if="contactPerson.city && contactPerson.city.value">
									<span>Ort</span>
								</div>
								<div class="col-9 contact-field" v-if="contactPerson.city && contactPerson.city.value">
									<span>{{ contactPerson.city.value }}</span>
								</div>
								<div class="col-3 contact-field" v-if="contactPerson.street && contactPerson.street.value">
									<span>Straße</span>
								</div>
								<div class="col-9 contact-field" v-if="contactPerson.street && contactPerson.street.value">
									<span>{{ contactPerson.street.value }}</span>
								</div>
								<div class="col-3 contact-field" v-if="contactPerson.postcode && contactPerson.postcode.value">
									<span>PLZ</span>
								</div>
								<div class="col-9 contact-field" v-if="contactPerson.postcode && contactPerson.postcode.value">
									<span>{{ contactPerson.postcode.value }}</span>
								</div>
								<div class="col-3 contact-field" v-if="contactPerson.phone && contactPerson.phone.value">
									<span>Telefon</span>
								</div>
								<div class="col-9 contact-field" v-if="contactPerson.phone && contactPerson.phone.value">
									<span><a :href="`tel:${contactPerson.phone.value}`">{{ contactPerson.phone.value }}</a></span>
								</div>
								<div class="col-3 contact-field" v-if="contactPerson.mail && contactPerson.mail.value">
									<span>E-Mail</span>
								</div>
								<div class="col-9 contact-field" v-if="contactPerson.mail && contactPerson.mail.value">
									<span><a :href="`mailto:${contactPerson.mail.value}`">{{ contactPerson.mail.value }}</a></span>
								</div>
								<div class="col-3 contact-field" v-if="mainSettings.footnote.socialNetworks != undefined">
									<span>Social-Media</span>
								</div>
								<div class="col-9 contact-field" v-if="mainSettings.footnote.socialNetworks != undefined">
									<template v-for="(social, index) in mainSettings.footnote" :key="index">
										<div class="social-block" v-if="index == 'socialNetworks' && social.values != ''">
											<div class="social-icon" v-if="social.values.facebook">
												<a :href="social.values.facebook" target="blank">
													<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<path id="facebook-square-brands" fill="currentColor"
															d="M17.86,0H2.14A2.14,2.14,0,0,0,0,2.15H0V17.86A2.14,2.14,0,0,0,2.14,20H8.27V13.2H5.46V10H8.27V7.57c0-2.78,1.65-4.31,4.18-4.31a17.17,17.17,0,0,1,2.48.21V6.2h-1.4a1.59,1.59,0,0,0-1.79,1.38,1.36,1.36,0,0,0,0,.35V10H14.8l-.49,3.2H11.73V20h6.13A2.14,2.14,0,0,0,20,17.86h0V2.15A2.14,2.14,0,0,0,17.86,0Z" />
													</svg>
												</a>
											</div>
											<div class="social-icon" v-if="social.values.instagram">
												<a :href="social.values.instagram" target="blank">
													<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<path id="instagram-square-brands" fill="currentColor"
															d="M10,7.62A2.38,2.38,0,1,0,12.38,10,2.39,2.39,0,0,0,10,7.62Zm5.57-1.83a2.45,2.45,0,0,0-1.36-1.36A16.06,16.06,0,0,0,10,4.14a16.06,16.06,0,0,0-4.21.29A2.45,2.45,0,0,0,4.43,5.79,16.06,16.06,0,0,0,4.14,10a16.06,16.06,0,0,0,.29,4.21,2.45,2.45,0,0,0,1.36,1.36,16.09,16.09,0,0,0,4.21.29,16.06,16.06,0,0,0,4.21-.29,2.45,2.45,0,0,0,1.36-1.36A16.06,16.06,0,0,0,15.86,10a16.06,16.06,0,0,0-.29-4.21ZM10,13.66a3.65,3.65,0,1,1,2.59-1.07A3.65,3.65,0,0,1,10,13.66ZM13.81,7A.84.84,0,0,1,13,6.19a.85.85,0,1,1,1.7,0,.84.84,0,0,1-.25.6A.86.86,0,0,1,13.81,7Zm4-7H2.14A2.14,2.14,0,0,0,0,2.14H0V17.86A2.14,2.14,0,0,0,2.14,20H17.86A2.14,2.14,0,0,0,20,17.86h0V2.14A2.14,2.14,0,0,0,17.86,0Zm-.77,13a4.25,4.25,0,0,1-1.15,3,4.25,4.25,0,0,1-3,1.15c-1.18.07-4.72.07-5.9,0a4.27,4.27,0,0,1-3-1.15,4.25,4.25,0,0,1-1.15-3c-.07-1.18-.07-4.72,0-5.9a4.25,4.25,0,0,1,1.15-3,4.27,4.27,0,0,1,3-1.15c1.17-.07,4.71-.07,5.89,0a4.25,4.25,0,0,1,3,1.15,4.27,4.27,0,0,1,1.15,3C17.16,8.23,17.16,11.77,17.09,13Z" />
													</svg>
												</a>
											</div>
											<div class="social-icon" v-if="social.values.twitter">
												<a :href="social.values.twitter" target="blank">
													<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<path id="twitter-square-brands" fill="currentColor"
															d="M17.86,0H2.14A2.14,2.14,0,0,0,0,2.14H0V17.86A2.14,2.14,0,0,0,2.14,20H17.86A2.14,2.14,0,0,0,20,17.86h0V2.14A2.14,2.14,0,0,0,17.86,0ZM15.67,7.09c0,.12,0,.25,0,.38A8.27,8.27,0,0,1,7.47,15.8H7.35a8.37,8.37,0,0,1-4.5-1.31c.24,0,.47,0,.71,0A5.8,5.8,0,0,0,7.2,13.27a2.94,2.94,0,0,1-2.74-2,3.09,3.09,0,0,0,1.32-.05A2.92,2.92,0,0,1,3.44,8.31v0a3,3,0,0,0,1.32.37,2.93,2.93,0,0,1-1.3-2.44,2.86,2.86,0,0,1,.4-1.48,8.3,8.3,0,0,0,6,3.06,2.93,2.93,0,0,1,5-2.67,5.6,5.6,0,0,0,1.86-.71A2.92,2.92,0,0,1,15.46,6a5.72,5.72,0,0,0,1.69-.46A6.11,6.11,0,0,1,15.67,7.09Z" />
													</svg>
												</a>
											</div>
											<div class="social-icon" v-if="social.values.youtube">
												<a :href="social.values.youtube" target="blank">
													<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<path id="youtube-square-brands" fill="currentColor"
															d="M8.34,7.59,12.59,10,8.34,12.42ZM20,2.14V17.86A2.14,2.14,0,0,1,17.86,20H2.14A2.14,2.14,0,0,1,0,17.86H0V2.14A2.14,2.14,0,0,1,2.14,0H17.86A2.14,2.14,0,0,1,20,2.14ZM18.12,10a21.57,21.57,0,0,0-.33-3.93,2,2,0,0,0-1.44-1.45A48.17,48.17,0,0,0,10,4.29a48.17,48.17,0,0,0-6.35.34A2,2,0,0,0,2.21,6.08a23.11,23.11,0,0,0,0,7.87,2,2,0,0,0,1.44,1.43,48.16,48.16,0,0,0,6.35.33,48.17,48.17,0,0,0,6.35-.34A2,2,0,0,0,17.78,14,20.83,20.83,0,0,0,18.12,10Z" />
													</svg>
												</a>
											</div>
											<div class="social-icon" v-if="social.values.linkedin">
												<a :href="social.values.linkedin" target="blank">
													<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<defs></defs>
														<path fill="currentColor"
															d="M18.57,0H1.42A1.44,1.44,0,0,0,0,1.45V18.56A1.43,1.43,0,0,0,1.42,20H18.57A1.43,1.43,0,0,0,20,18.56V1.45A1.44,1.44,0,0,0,18.57,0ZM6,17.15h-3V7.6h3v9.55ZM4.56,6.3A1.72,1.72,0,1,1,6.28,4.58,1.72,1.72,0,0,1,4.56,6.3Zm12.6,10.85h-3V12.5c0-1.1,0-2.53-1.54-2.53s-1.78,1.21-1.78,2.45v4.73h-3V7.6h2.84V8.91h0A3.13,3.13,0,0,1,13.6,7.37c3,0,3.56,2,3.56,4.55Z" />
													</svg>
												</a>
											</div>
											<div class="social-icon" v-if="social.values.xing">
												<a :href="social.values.xing" target="blank">
													<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<defs></defs>
														<path fill="currentColor"
															d="M17.86,0H2.14A2.14,2.14,0,0,0,0,2.14V17.86A2.14,2.14,0,0,0,2.14,20H17.86A2.14,2.14,0,0,0,20,17.86V2.14A2.14,2.14,0,0,0,17.86,0ZM6.27,12.87H4.19a.3.3,0,0,1-.27-.46l2.2-3.87s0,0,0,0L4.72,6.12A.28.28,0,0,1,5,5.67H7.07a.65.65,0,0,1,.57.38L9.07,8.52,6.83,12.46c-.16.28-.34.41-.56.41Zm9.81-9.56-4.59,8.06h0l2.92,5.32a.28.28,0,0,1-.27.45H12.06a.64.64,0,0,1-.57-.39l-3-5.37q.15-.27,4.62-8.14a.63.63,0,0,1,.55-.39h2.1a.29.29,0,0,1,.27.45Z" />
													</svg>
												</a>
											</div>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>

export default {
	props: {
		contactPersonData: {
			type: Object
		},
		mainSettings: {
			type: Object
		},
		index: {
			type: Number
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/contactPersonComponent.scss";
</style>